module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_bd_06.d3b4a0d2.jpg";